// 通用 CSV 导出（前端）
// columns: [{ label, value?: (row)=>any, key?: string }]
export function downloadCsv(filename, columns, rows) {
    const escape = (v) => {
        const s = v == null ? '' : String(v);
        return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const header = columns.map((c) => escape(c.label)).join(',');
    const body = rows.map((row) => columns.map((c) => escape(c.value ? c.value(row) : row[c.key])).join(',')).join('\n');
    const csv = '\ufeff' + header + '\n' + body;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
